module.exports = __webpack_public_path__ + "media/icons/tapicerka-skorzana-active@3x-223b5356.svg";